import React, { useEffect, useState } from "react";

import { Alert, Button, Col, Row } from "@intech/web-ui";

import { EmprestimoService } from "../../../services";
import { ContratoEntidade } from "../../../entidades";
import { useHistory } from "react-router-dom";
import { LoadingComponent } from "../../../components/LoadingComponent";
import { Detalhe } from "./Detalhe";
import { Prestacoes } from "./Prestacoes";
import { MasterPage } from "../../../components/MasterPage";
import { NumFuncionalidade } from "../../../helpers/BloqueioFuncionalidade";

interface IProps {
  match?: any;
}

export interface ColProps {
  size: number;
}

export const EmprestimoDetalhe: React.FC<IProps> = ({
  match,
  ...props
}) => {
  const history = useHistory();

  const [AlertText, setAlertText] = useState<string>("");
  const [Numero, setNumero] = useState<string>(match.params.numero);
  const [Ano, setAno] = useState<string>(match.params.ano);
  const [Detalhes, setDetalhes] = useState<ContratoEntidade>();
  // const [Prestacoes, setPrestacoes] = useState<Array<PrestacaoEntidade>>();
  const [Pensionista, setPensionista] = useState<boolean>(localStorage.getItem("pensionista") == "true");

  useEffect(() => {
    (async () => {
      try {
        const detalhes = await EmprestimoService.BuscarDetalhePorNumeroAno(Numero, Ano);

        setDetalhes(detalhes);
      }
      catch (e) {
        if (e.message.indexOf("401") > -1) {
          history.push("/login");
        }
        const error = e.response ? e.response.data : e;
        setAlertText(error);
      }
    })();
  }, []);

  function Voltar() {
    history.push("/emprestimos");
  }

  function renderEmprestimoDetalhe() {
    if (Detalhes !== undefined) {
      return (
        <Row>
          <Col>
            <Detalhe detalhe={Detalhes} pensionista={Pensionista} />
          </Col>
          <Col>
            <Prestacoes prestacoes={Detalhes.Prestacoes} />
          </Col>
        </Row>
      );
    }

    if (AlertText !== "") {
      return (
        <Alert type={"danger"}>
          {AlertText}
        </Alert>
      );
    }

    return <LoadingComponent />;
  };

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.EMPRESTIMOS_CONSULTA} {...props}>
      <Button
        onClick={Voltar}
        title={"Voltar"}
        type={"primary"}
      />
      <br />
      <br />

      {renderEmprestimoDetalhe()}
    </MasterPage>
  );
}
